module.exports = __webpack_public_path__ + "assets/img/00019.aff91c07.png";